import { TimelineLine, TweenLite } from 'gsap';
import _forEach from 'lodash/forEach';

class HomesAnimation {
  constructor() {
    this.triggers = [];
    this.afterLoadTriggers = [];
    this.loaded = false;
  }

  isHomesPage = () => {
    return document.body.classList.contains('page-homes');
  };

  init = () => {
    window.addEventListener('load', this.onLoad);
    window.addEventListener('scroll', this.onScroll);
  };

  onLoad = () => {
    if (!this.isHomesPage()) {
      return;
    }
    this.loaded = true;
    window.setTimeout(this.startAnimation, 100);
  };

  startAnimation = () => {
    this.addAfterLoadTriggers();
    this.initHero();
    this.addTrigger(
      10,
      '.site-header',
      this.animateHero
    );
    this.initDifferencePoints();
    this.addTrigger(
      20,
      '.residently-difference .highlights__item',
      this.animateDifferencePoints
    );
   
    this.triggerActiveTriggers();
  }

  // If you're looking for 'opacity = 0', that's been done in CSS with the 'animated' class.
  initHero = () => {
    const siteIdentityOuter = document.querySelector('.site-identity-outer');
    siteIdentityOuter.style.transform = 'translateY(-200%)';
  };

  animateHero = (tl) => {
    const siteIdentityOuter = document.querySelector('.site-identity-outer');
    const nav = document.querySelector('.site-nav');
    const heroPrimary = document.querySelector('.site-hero-headline-primary');
    const heroSub = document.querySelector('.site-hero-headline-sub');
    siteIdentityOuter.style.opacity = 1;
    tl.to(
      siteIdentityOuter,
      0.7,
      {
        transform: 'translateY(0)',
        ease: Power3.easeOut
      }
    );
    tl.to(
      nav,
      0.7,
      { opacity: 1.0 },
      '-=0.7'
    );
    tl.to(
      heroPrimary,
      0.5,
      { opacity: 1.0 },
      '-=0.4'
    );
    tl.to(
      heroSub,
      0.5,
      { opacity: 1.0 },
      '-=0.2'
    );
  };

  initDifferencePoints = () => {
    const highlightsItems = document.querySelectorAll('.residently-difference .highlights__item');
    _forEach(highlightsItems, item => {
      item.style.transform = 'translateX(10%)';
    });
  };

  animateDifferencePoints = (tl) => {
    const highlightsItems = document.querySelectorAll('.residently-difference .highlights__item');
    tl.staggerTo(
      highlightsItems,
      1.0,
      {
        opacity: 1.0,
        transform: 'translateX(0)',
        ease: Power3.easeOut
      },
      0.1,
      '-=0.2'
    );
  };

  addTrigger = (priority, selector, callback) => {
    const element = document.querySelector(selector);
    const elementBounds = element.getBoundingClientRect();
    const trigger = {
      priority,
      top: elementBounds.top + (window.scrollY || window.pageYOffset),
      bottom: elementBounds.bottom + (window.scrollY || window.pageYOffset),
      callback,
      triggered: false
    };
    this.triggers.push(trigger);
    this.triggers.sort((a, b) => a.priority - b.priority);
  };

  addTriggerAfterLoad = (priority, selector, callback) => {
    if (this.loaded) {
      this.addTrigger(priority, selector, callback);
    } else {
      this.afterLoadTriggers.push([priority, selector, callback]);
    }
  };

  addAfterLoadTriggers = () => {
    _forEach(this.afterLoadTriggers, triggerArgs => this.addTrigger(...triggerArgs));
  };

  isTriggerActive = (trigger, selector) => {
    const viewportHeight = window.innerHeight;
    const viewportTop = window.scrollY || window.pageYOffset;
    const viewportBottom = viewportTop + viewportHeight;
    const viewportEdge = viewportHeight * 0.15;
    const triggerZoneTop = viewportTop + viewportEdge;
    const triggerZoneBottom = viewportBottom - viewportEdge;

    const inView = (
      (triggerZoneTop <= trigger.top && trigger.top <= triggerZoneBottom) ||
      (triggerZoneTop <= trigger.bottom && trigger.bottom <= triggerZoneBottom) ||
      (trigger.top <= triggerZoneTop && triggerZoneBottom <= trigger.bottom)
    );
    return inView;
  };

  onScroll = () => {
    if (!this.isHomesPage()) {
      return;
    }
    this.triggerActiveTriggers();
  };

  triggerActiveTriggers = () => {

    const masterTl = new TimelineLite();
    masterTl.pause();
    let isFirstTrigger = true;
    _forEach(this.triggers, trigger => {
      if (this.isTriggerActive(trigger)) {
        const childTl = new TimelineLite();
        trigger.callback(childTl);
        if (isFirstTrigger) {
          masterTl.add(
            childTl
          );
          isFirstTrigger = false;
        } else {
          masterTl.add(
            childTl,
            '-=0.9'
          );
        }
        trigger.triggered = true;
      }
    });
    masterTl.play();
    this.triggers = this.triggers.filter(trigger => !trigger.triggered);
  };
};

export default new HomesAnimation;